import { render } from "./account-settings-modal.vue?vue&type=template&id=66a65c72&ts=true"
import script from "./account-settings-modal.vue?vue&type=script&lang=ts"
export * from "./account-settings-modal.vue?vue&type=script&lang=ts"

import "./account-settings-modal.vue?vue&type=style&index=0&id=66a65c72&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__